<template>
  <v-text-field
    v-model="inputValue"
    @blur="updateValue"
    :label="props.label"
    :variant="props.variant"
  ></v-text-field>
  <!-- <input v-model="inputValue" v-maska data-maska="['(##) ####-####', '(##) #####-####']"> -->
  <!-- <v-text-field v-maska="'tasdasd'" v-model="inputValue" /> -->
</template>
<script setup>
// import { vMaska } from "maska/vue"
import { ref } from 'vue'

const emits = defineEmits('update')
const model = defineModel({ required: true })
const props = defineProps(['label', 'variant'])

const inputValue = ref(model.value)

const updateValue = () => {
  emits('update', inputValue.value)
  model.value = inputValue.value
}
</script>
